import type { Size } from '@sds-system/types';

export const size: Size = {
  '3XS': 16,
  '2XS': 20,
  XS: 24,
  S: 32,
  M: 40,
  L: 48,
  XL: 56,
  '2XL': 64,
  '3XL': 72,
  '4XL': 80,
};
